module.exports = __webpack_public_path__ + "static/media/water-rise.f93f6a1e.svg";